export type Language = "en" | "lo" | "zh" | "th";

export const translations = {
  en: {
    nav: {
      classes: "Classes",
      trainers: "Trainers",
      pricing: "Pricing",
      shop: "Shop",
      contact: "Contact",
      feed: "Feed",
      joinNow: "Join Now",
    },
    hero: {
      tagline: "Transform Your Body",
      title1: "PUSH YOUR",
      title2: "LIMITS",
      description: "Join the most exclusive fitness community. State-of-the-art equipment, world-class trainers, and VIP programs designed to transform your body.",
      startTrial: "Start Free Trial",
      watchVideo: "Watch Video",
      members: "Members",
      classes: "Classes",
      trainers: "Trainers",
    },
    classesSection: {
      title: "FEATURED CLASSES",
      subtitle: "Discover our wide range of classes designed to challenge and transform you",
      viewSchedule: "View Schedule",
      bookNow: "Book Now",
      classes: {
        pilates: { name: "Pilates", description: "Core-focused workout using specialized equipment to build strength and flexibility." },
        sprint: { name: "Sprint", description: "High-energy indoor cycling with immersive lighting and music." },
        trx: { name: "TRX", description: "Suspension training that uses bodyweight exercises for total body strength." },
        bodypump: { name: "Bodypump", description: "Full-body barbell workout targeting all major muscle groups." },
        combat: { name: "Combat", description: "Martial arts-inspired cardio workout for strength and endurance." },
        zumba: { name: "Zumba", description: "Dance fitness party with Latin and international music." },
      },
    },
    trainersSection: {
      title: "ELITE TRAINERS",
      subtitle: "Learn from the best in the industry",
      trainers: {
        nera: { name: "Neramit Sujarit (Nera)", specialty: "Group Exercise & MMA GX" },
        day: { name: "Lipatpong Buangam (Day)", specialty: "Strength & Conditioning" },
      },
    },
    pricingSection: {
      title: "PRICE LIST",
      subtitle: "Choose the plan that fits your fitness journey",
      getStarted: "Get Started",
      hour: "HOUR",
      categories: {
        pilates: {
          name: "PILATES REFORMER",
          plans: [
            { hours: "1", price: "18" },
            { hours: "10", price: "160" },
            { hours: "20", price: "300" },
            { hours: "30", price: "390" },
          ],
        },
        privateClass: {
          name: "PRIVATE CLASS (TEACHER NERA)",
          plans: [
            { hours: "1", price: "45" },
            { hours: "10", price: "390" },
            { hours: "20", price: "760" },
            { hours: "30", price: "1080" },
          ],
        },
        muayThai: {
          name: "MUAY THAI & GROUP EXERCISE",
          plans: [
            { hours: "1", price: "10" },
            { hours: "10", price: "90" },
            { hours: "20", price: "160" },
            { hours: "30", price: "210" },
            { hours: "50", price: "300" },
          ],
        },
      },
    },
    shopSection: {
      title: "SHOP",
      subtitle: "Premium fitness gear and supplements",
      addToCart: "Add to Cart",
      viewCart: "View Cart",
      checkout: "Checkout",
      emptyCart: "Your cart is empty",
      noProducts: "No products available yet",
    },
    contactSection: {
      title: "Contact Information",
      phone: "Phone",
      whatsapp: "WhatsApp",
      facebook: "Facebook",
      mainOffice: "Main Office",
    },
    footer: {
      description: "Transform your body and mind with the most exclusive fitness community.",
      quickLinks: "Quick Links",
      schedule: "Schedule",
      blog: "Blog",
      hours: "Hours",
      monSun: "Mon - Sun",
      contactTitle: "Contact",
      copyright: "© 2026 VIP Fitness Club. All rights reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
    },
    chat: {
      title: "Chat with us",
      subtitle: "We typically reply within minutes",
      namePlaceholder: "Your name *",
      emailPlaceholder: "Email",
      phonePlaceholder: "Phone",
      messagePlaceholder: "How can we help you? *",
      sendButton: "Send Message",
      requiredFields: "Please fill in required fields",
      messageSent: "Message sent successfully!",
      messageError: "Failed to send message",
    },
    reels: {
      tagline: "LATEST UPDATES",
      title: "FITNESS REELS",
    },
    crm: {
      sources: { manual: "Manual", walk_in: "Walk-in", tiktok: "TikTok", facebook: "Facebook", whatsapp: "WhatsApp", referral: "Referral / Friend", advertisement: "Advertisement", corporate: "Corporate", website: "Website", social: "Social Media", other: "Other" },
      status: { new_lead: "New Lead", contacted: "Contacted", interested: "Interested", trial: "Trial", follow_up: "Follow-up", negotiation: "Negotiation", won: "Won", lost: "Lost" },
      report: {
        tab: "Sources", title: "Lead Sources Report", monthly: "Monthly", yearly: "Yearly",
        source: "Source", leads: "New Leads", trials: "Trials", won: "Won", lost: "Lost",
        revenue: "Revenue", convRate: "Close Rate", total: "Total", noData: "No leads in this period",
        topSource: "Top source", allSources: "All sources", statusLabel: "Sales Status",
        markWon: "Mark Won", markLost: "Mark Lost", dealValue: "Sale value", wonValue: "Sale value",
        confirmWon: "Close the sale for this customer?", lostReason: "Reason (optional)",
        exportCsv: "Export CSV", cancel: "Cancel", confirm: "Confirm", sourceDetail: "Source detail",
      },
      portal: { back: "Back to Admin", title: "CRM Portal" },
      header: { title: "CRM", subtitle: "Contacts, sales pipeline, tasks, and activity audit trail" },
      tabs: { contacts: "Contacts", pipeline: "Pipeline", tasks: "Tasks", activity: "Activity Log" },
      stats: { contacts: "Contacts", openDeals: "Open Deals", pipelineValue: "Pipeline Value", openTasks: "Open Tasks", wonThisMonth: "Won This Month" },
      lifecycle: { lead: "Lead", prospect: "Prospect", customer: "Customer", member: "Member", churned: "Churned" },
      contacts: {
        title: "Contacts", newContact: "New Contact",
        searchPlaceholder: "Search by name, email, phone…", allStages: "All stages",
        name: "Name", contact: "Contact", stage: "Stage", source: "Source", created: "Created",
        noContacts: "No contacts found", showingFirst: "Showing first 200 results — refine your search to narrow down.",
        loadFailed: "Failed to load contacts",
      },
      newContact: {
        title: "New Contact", fullName: "Full Name *", email: "Email", phone: "Phone", whatsapp: "WhatsApp",
        source: "Source", lifecycleStage: "Lifecycle Stage", notes: "Notes",
        cancel: "Cancel", create: "Create Contact", saving: "Saving…",
        nameRequired: "Name is required", created: "Contact created",
        sources: { manual: "Manual", walk_in: "Walk-in", website: "Website", referral: "Referral", social: "Social Media" },
      },
      detail: {
        details: "Details", timeline: "Timeline", tasks: "Tasks", deals: "Deals",
        fullName: "Full Name", email: "Email", phone: "Phone", whatsapp: "WhatsApp",
        source: "Source", lifecycleStage: "Lifecycle Stage", notes: "Notes",
        save: "Save Changes", saving: "Saving…", updated: "Contact updated",
        addNotePlaceholder: "Add a note about this contact…", log: "Log", noActivity: "No activity yet",
        taskTitle: "Task title", low: "Low", med: "Med", high: "High",
        noTasks: "No tasks", noDueDate: "No due date", taskAdded: "Task added",
        dealTitle: "Deal title (e.g. 1Y Membership)", dealValue: "Value", stage: "Stage",
        noDeals: "No deals", titleStageRequired: "Title and stage required",
      },
      pipeline: {
        title: "Sales Pipeline", total: "total", dropHere: "Drop deals here",
        hint: "💡 Drag deals between stages to update them. Create deals from a contact's detail page.",
        moveFailed: "Failed to move deal",
      },
      tasks: {
        title: "Tasks & Follow-ups",
        overdue: "Overdue", today: "Today", upcoming: "Upcoming", done: "Done",
        noTasks: "No tasks here", noDueDate: "No due date",
      },
      activity: {
        searchPlaceholder: "Search activity, contact, actor...",
        allActors: "All actors", system: "System", allActivities: "All activities", clear: "Clear",
        showing: "Showing", of: "of", activities: "activities",
        noMatch: "No activity matches the current filters",
        types: {
          contact_created: "Contact created", contact_updated: "Contact updated",
          deal_created: "Deal created", deal_stage_moved: "Stage moved", deal_updated: "Deal updated",
          task_created: "Task created", task_updated: "Task updated",
          task_completed: "Task completed", task_deleted: "Task deleted",
        },
      },
    },
  },
  lo: {
    nav: {
      classes: "ຫ້ອງຮຽນ",
      trainers: "ຄູຝຶກ",
      pricing: "ລາຄາ",
      shop: "ຮ້ານຄ້າ",
      contact: "ຕິດຕໍ່",
      feed: "ຟີດ",
      joinNow: "ສະໝັກດຽວນີ້",
    },
    hero: {
      tagline: "ປ່ຽນແປງຮ່າງກາຍຂອງທ່ານ",
      title1: "ຊຸກຍູ້",
      title2: "ຂີດຈຳກັດ",
      description: "ເຂົ້າຮ່ວມຊຸມຊົນອອກກຳລັງກາຍທີ່ພິເສດທີ່ສຸດ. ອຸປະກອນທັນສະໄໝ, ຄູຝຶກລະດັບໂລກ, ແລະໂປຣແກຣມ VIP ທີ່ອອກແບບມາເພື່ອປ່ຽນແປງຮ່າງກາຍຂອງທ່ານ.",
      startTrial: "ເລີ່ມທົດລອງຟຣີ",
      watchVideo: "ເບິ່ງວິດີໂອ",
      members: "ສະມາຊິກ",
      classes: "ຫ້ອງຮຽນ",
      trainers: "ຄູຝຶກ",
    },
    classesSection: {
      title: "ຫ້ອງຮຽນແນະນຳ",
      subtitle: "ຄົ້ນພົບຫ້ອງຮຽນຫຼາກຫຼາຍຂອງພວກເຮົາທີ່ອອກແບບມາເພື່ອທ້າທາຍ ແລະ ປ່ຽນແປງທ່ານ",
      viewSchedule: "ເບິ່ງຕາຕະລາງ",
      bookNow: "ຈອງດຽວນີ້",
      classes: {
        pilates: { name: "Pilates", description: "ການອອກກຳລັງກາຍເນັ້ນແກນກາງໂດຍໃຊ້ອຸປະກອນພິເສດເພື່ອສ້າງກຳລັງ ແລະ ຄວາມຍືດຫຍຸ່ນ." },
        sprint: { name: "Sprint", description: "ການປັ່ນຈັກຍານພະລັງງານສູງພ້ອມແສງສີ ແລະ ເພງທີ່ດຶງດູດ." },
        trx: { name: "TRX", description: "ການຝຶກແບບແຂວນໂດຍໃຊ້ນ້ຳໜັກຮ່າງກາຍເພື່ອພະລັງທັງໝົດ." },
        bodypump: { name: "Bodypump", description: "ການອອກກຳລັງກາຍທັງໝົດດ້ວຍ barbell ເນັ້ນກ້າມຊີ້ນຫຼັກ." },
        combat: { name: "Combat", description: "ການອອກກຳລັງກາຍ cardio ແບບສິນລະປະປ້ອງກັນຕົວ." },
        zumba: { name: "Zumba", description: "ປາກຕີ້ອອກກຳລັງກາຍກັບເພງລາຕິນ ແລະ ສາກົນ." },
      },
    },
    trainersSection: {
      title: "ຄູຝຶກຊັ້ນນຳ",
      subtitle: "ຮຽນຮູ້ຈາກທີ່ດີທີ່ສຸດໃນອຸດສາຫະກຳ",
      trainers: {
        nera: { name: "Neramit Sujarit (Nera)", specialty: "ອອກກຳລັງກາຍກຸ່ມ & MMA GX" },
        day: { name: "Lipatpong Buangam (Day)", specialty: "ພະລັງ ແລະ ຄວາມແຂງແຮງ" },
      },
    },
    pricingSection: {
      title: "ລາຄາ",
      subtitle: "ເລືອກແຜນທີ່ເໝາະສົມກັບການເດີນທາງອອກກຳລັງກາຍຂອງທ່ານ",
      getStarted: "ເລີ່ມຕົ້ນ",
      hour: "ຊົ່ວໂມງ",
      categories: {
        pilates: {
          name: "PILATES REFORMER",
          plans: [
            { hours: "1", price: "18" },
            { hours: "10", price: "160" },
            { hours: "20", price: "300" },
            { hours: "30", price: "390" },
          ],
        },
        privateClass: {
          name: "ຫ້ອງຮຽນສ່ວນຕົວ (ຄູ NERA)",
          plans: [
            { hours: "1", price: "45" },
            { hours: "10", price: "390" },
            { hours: "20", price: "760" },
            { hours: "30", price: "1080" },
          ],
        },
        muayThai: {
          name: "ມວຍໄທ ແລະ ກຸ່ມອອກກຳລັງກາຍ",
          plans: [
            { hours: "1", price: "10" },
            { hours: "10", price: "90" },
            { hours: "20", price: "160" },
            { hours: "30", price: "210" },
            { hours: "50", price: "300" },
          ],
        },
      },
    },
    shopSection: {
      title: "ຮ້ານຄ້າ",
      subtitle: "ອຸປະກອນອອກກຳລັງກາຍແລະອາຫານເສີມລະດັບພຣີມຽມ",
      addToCart: "ເພີ່ມໃສ່ກະຕ່າ",
      viewCart: "ເບິ່ງກະຕ່າ",
      checkout: "ຊຳລະເງິນ",
      emptyCart: "ກະຕ່າຂອງທ່ານຫວ່າງເປົ່າ",
      noProducts: "ຍັງບໍ່ມີສິນຄ້າ",
    },
    contactSection: {
      title: "ຂໍ້ມູນການຕິດຕໍ່",
      phone: "ໂທລະສັບ",
      whatsapp: "WhatsApp",
      facebook: "Facebook",
      mainOffice: "ຫ້ອງການໃຫຍ່",
    },
    footer: {
      description: "ປ່ຽນແປງຮ່າງກາຍ ແລະ ຈິດໃຈຂອງທ່ານກັບຊຸມຊົນອອກກຳລັງກາຍທີ່ພິເສດທີ່ສຸດ.",
      quickLinks: "ລິ້ງດ່ວນ",
      schedule: "ຕາຕະລາງ",
      blog: "ບລັອກ",
      hours: "ຊົ່ວໂມງ",
      monSun: "ຈັນ - ອາທິດ",
      contactTitle: "ຕິດຕໍ່",
      copyright: "© 2026 VIP Fitness Club. ສະຫງວນລິຂະສິດ.",
      privacy: "ນະໂຍບາຍຄວາມເປັນສ່ວນຕົວ",
      terms: "ເງື່ອນໄຂການໃຊ້ບໍລິການ",
    },
    chat: {
      title: "ສົນທະນາກັບພວກເຮົາ",
      subtitle: "ພວກເຮົາຕອບກັບພາຍໃນບໍ່ເທົ່າໃດນາທີ",
      namePlaceholder: "ຊື່ຂອງທ່ານ *",
      emailPlaceholder: "ອີເມວ",
      phonePlaceholder: "ເບີໂທ",
      messagePlaceholder: "ພວກເຮົາຊ່ວຍທ່ານໄດ້ແນວໃດ? *",
      sendButton: "ສົ່ງຂໍ້ຄວາມ",
      requiredFields: "ກະລຸນາປ້ອນຂໍ້ມູນທີ່ຈຳເປັນ",
      messageSent: "ສົ່ງຂໍ້ຄວາມສຳເລັດ!",
      messageError: "ສົ່ງຂໍ້ຄວາມບໍ່ສຳເລັດ",
    },
    reels: {
      tagline: "ອັບເດດຫຼ້າສຸດ",
      title: "ວິດີໂອອອກກຳລັງກາຍ",
    },
    crm: {
      sources: { manual: "ເພີ່ມດ້ວຍມື", walk_in: "Walk-in", tiktok: "TikTok", facebook: "Facebook", whatsapp: "WhatsApp", referral: "ໝູ່ແນະນຳ", advertisement: "ໂຄສະນາ", corporate: "ອົງກອນ/ບໍລິສັດ", website: "ເວັບໄຊ", social: "ໂຊຊຽວມີເດຍ", other: "ອື່ນໆ" },
      status: { new_lead: "ລູກຄ້າໃໝ່", contacted: "ຕິດຕໍ່ແລ້ວ", interested: "ສົນໃຈ", trial: "ທົດລອງ", follow_up: "ຕິດຕາມ", negotiation: "ເຈລະຈາ", won: "ປິດການຂາຍ", lost: "ບໍ່ສຳເລັດ" },
      report: {
        tab: "ແຫຼ່ງທີ່ມາ", title: "ລາຍງານແຫຼ່ງທີ່ມາຂອງລູກຄ້າ", monthly: "ລາຍເດືອນ", yearly: "ລາຍປີ",
        source: "ແຫຼ່ງທີ່ມາ", leads: "ລູກຄ້າໃໝ່", trials: "ມາທົດລອງ", won: "ປິດການຂາຍ", lost: "ບໍ່ສຳເລັດ",
        revenue: "ຍອດຂາຍ", convRate: "ອັດຕາປິດການຂາຍ", total: "ລວມ", noData: "ບໍ່ມີລູກຄ້າໃນຊ່ວງນີ້",
        topSource: "ຊ່ອງທາງດີທີ່ສຸດ", allSources: "ທຸກຊ່ອງທາງ", statusLabel: "ສະຖານະການຂາຍ",
        markWon: "ປິດການຂາຍ", markLost: "ບໍ່ສຳເລັດ", dealValue: "ມູນຄ່າການຂາຍ", wonValue: "ມູນຄ່າການຂາຍ",
        confirmWon: "ຢືນຢັນປິດການຂາຍລູກຄ້າຄົນນີ້?", lostReason: "ເຫດຜົນ (ບໍ່ບັງຄັບ)",
        exportCsv: "ດາວໂຫຼດ CSV", cancel: "ຍົກເລີກ", confirm: "ຢືນຢັນ", sourceDetail: "ລາຍລະອຽດແຫຼ່ງທີ່ມາ",
      },
      portal: { back: "ກັບໄປຫາ Admin", title: "ສູນ CRM" },
      header: { title: "CRM", subtitle: "ຜູ້ຕິດຕໍ່, ທໍ່ການຂາຍ, ໜ້າວຽກ ແລະ ບັນທຶກກິດຈະກຳ" },
      tabs: { contacts: "ຜູ້ຕິດຕໍ່", pipeline: "ທໍ່ການຂາຍ", tasks: "ໜ້າວຽກ", activity: "ບັນທຶກກິດຈະກຳ" },
      stats: { contacts: "ຜູ້ຕິດຕໍ່", openDeals: "ດີລ໌ເປີດ", pipelineValue: "ມູນຄ່າທໍ່ການຂາຍ", openTasks: "ໜ້າວຽກເປີດ", wonThisMonth: "ຊະນະເດືອນນີ້" },
      lifecycle: { lead: "ລີດ", prospect: "ຜູ້ສົນໃຈ", customer: "ລູກຄ້າ", member: "ສະມາຊິກ", churned: "ຍົກເລີກແລ້ວ" },
      contacts: {
        title: "ຜູ້ຕິດຕໍ່", newContact: "ເພີ່ມຜູ້ຕິດຕໍ່",
        searchPlaceholder: "ຄົ້ນຫາຕາມຊື່, ອີເມວ, ໂທລະສັບ…", allStages: "ທຸກຂັ້ນ",
        name: "ຊື່", contact: "ຕິດຕໍ່", stage: "ຂັ້ນ", source: "ແຫຼ່ງທີ່ມາ", created: "ສ້າງເມື່ອ",
        noContacts: "ບໍ່ພົບຜູ້ຕິດຕໍ່", showingFirst: "ສະແດງ 200 ລາຍການທຳອິດ — ປັບການຄົ້ນຫາໃຫ້ແຄບລົງ.",
        loadFailed: "ໂຫຼດຜູ້ຕິດຕໍ່ບໍ່ສຳເລັດ",
      },
      newContact: {
        title: "ເພີ່ມຜູ້ຕິດຕໍ່", fullName: "ຊື່ເຕັມ *", email: "ອີເມວ", phone: "ໂທລະສັບ", whatsapp: "WhatsApp",
        source: "ແຫຼ່ງທີ່ມາ", lifecycleStage: "ຂັ້ນວົງຈອນ", notes: "ບັນທຶກ",
        cancel: "ຍົກເລີກ", create: "ສ້າງຜູ້ຕິດຕໍ່", saving: "ກຳລັງບັນທຶກ…",
        nameRequired: "ຕ້ອງລະບຸຊື່", created: "ສ້າງຜູ້ຕິດຕໍ່ສຳເລັດ",
        sources: { manual: "ປ້ອນເອງ", walk_in: "ມາເອງ", website: "ເວັບໄຊ", referral: "ແນະນຳ", social: "ໂຊຊຽວມີເດຍ" },
      },
      detail: {
        details: "ລາຍລະອຽດ", timeline: "ໄທມ໌ໄລນ໌", tasks: "ໜ້າວຽກ", deals: "ດີລ໌",
        fullName: "ຊື່ເຕັມ", email: "ອີເມວ", phone: "ໂທລະສັບ", whatsapp: "WhatsApp",
        source: "ແຫຼ່ງທີ່ມາ", lifecycleStage: "ຂັ້ນວົງຈອນ", notes: "ບັນທຶກ",
        save: "ບັນທຶກການປ່ຽນແປງ", saving: "ກຳລັງບັນທຶກ…", updated: "ອັບເດດຜູ້ຕິດຕໍ່ສຳເລັດ",
        addNotePlaceholder: "ເພີ່ມບັນທຶກກ່ຽວກັບຜູ້ຕິດຕໍ່ນີ້…", log: "ບັນທຶກ", noActivity: "ຍັງບໍ່ມີກິດຈະກຳ",
        taskTitle: "ຫົວຂໍ້ໜ້າວຽກ", low: "ຕ່ຳ", med: "ກາງ", high: "ສູງ",
        noTasks: "ບໍ່ມີໜ້າວຽກ", noDueDate: "ບໍ່ມີກຳນົດ", taskAdded: "ເພີ່ມໜ້າວຽກສຳເລັດ",
        dealTitle: "ຫົວຂໍ້ດີລ໌ (ເຊັ່ນ: ສະມາຊິກ 1 ປີ)", dealValue: "ມູນຄ່າ", stage: "ຂັ້ນ",
        noDeals: "ບໍ່ມີດີລ໌", titleStageRequired: "ຕ້ອງລະບຸຫົວຂໍ້ ແລະ ຂັ້ນ",
      },
      pipeline: {
        title: "ທໍ່ການຂາຍ", total: "ລວມ", dropHere: "ວາງດີລ໌ບ່ອນນີ້",
        hint: "💡 ລາກດີລ໌ລະຫວ່າງຂັ້ນເພື່ອອັບເດດ. ສ້າງດີລ໌ຈາກໜ້າລາຍລະອຽດຂອງຜູ້ຕິດຕໍ່.",
        moveFailed: "ຍ້າຍດີລ໌ບໍ່ສຳເລັດ",
      },
      tasks: {
        title: "ໜ້າວຽກ ແລະ ການຕິດຕາມ",
        overdue: "ເກີນກຳນົດ", today: "ມື້ນີ້", upcoming: "ໃກ້ມາ", done: "ສຳເລັດແລ້ວ",
        noTasks: "ບໍ່ມີໜ້າວຽກ", noDueDate: "ບໍ່ມີກຳນົດ",
      },
      activity: {
        searchPlaceholder: "ຄົ້ນຫາກິດຈະກຳ, ຜູ້ຕິດຕໍ່, ຜູ້ດຳເນີນການ...",
        allActors: "ທຸກຜູ້ດຳເນີນການ", system: "ລະບົບ", allActivities: "ກິດຈະກຳທັງໝົດ", clear: "ລ້າງ",
        showing: "ສະແດງ", of: "ຈາກ", activities: "ກິດຈະກຳ",
        noMatch: "ບໍ່ມີກິດຈະກຳທີ່ກົງກັບຕົວກອງ",
        types: {
          contact_created: "ສ້າງຜູ້ຕິດຕໍ່", contact_updated: "ອັບເດດຜູ້ຕິດຕໍ່",
          deal_created: "ສ້າງດີລ໌", deal_stage_moved: "ຍ້າຍຂັ້ນ", deal_updated: "ອັບເດດດີລ໌",
          task_created: "ສ້າງໜ້າວຽກ", task_updated: "ອັບເດດໜ້າວຽກ",
          task_completed: "ໜ້າວຽກສຳເລັດ", task_deleted: "ລຶບໜ້າວຽກ",
        },
      },
    },
  },
  zh: {
    nav: {
      classes: "课程",
      trainers: "教练",
      pricing: "价格",
      shop: "商店",
      contact: "联系",
      feed: "动态",
      joinNow: "立即加入",
    },
    hero: {
      tagline: "改变你的身体",
      title1: "突破你的",
      title2: "极限",
      description: "加入最尊贵的健身社区。最先进的设备，世界级教练，以及专为改变您身体而设计的VIP课程。",
      startTrial: "开始免费试用",
      watchVideo: "观看视频",
      members: "会员",
      classes: "课程",
      trainers: "教练",
    },
    classesSection: {
      title: "精选课程",
      subtitle: "发现我们为挑战和改变您而设计的各种课程",
      viewSchedule: "查看课程表",
      bookNow: "立即预约",
      classes: {
        pilates: { name: "普拉提", description: "使用专业设备进行核心训练，增强力量和柔韧性。" },
        sprint: { name: "动感单车", description: "沉浸式灯光和音乐下的高能量室内骑行。" },
        trx: { name: "TRX悬挂训练", description: "使用体重进行悬挂训练，全面增强力量。" },
        bodypump: { name: "杠铃操", description: "针对所有主要肌群的全身杠铃锻炼。" },
        combat: { name: "搏击操", description: "武术风格的有氧运动，增强力量和耐力。" },
        zumba: { name: "尊巴舞", description: "拉丁和国际音乐的舞蹈健身派对。" },
      },
    },
    trainersSection: {
      title: "精英教练",
      subtitle: "向业内最优秀的人学习",
      trainers: {
        nera: { name: "Neramit Sujarit (Nera)", specialty: "团体运动 & MMA GX" },
        day: { name: "Lipatpong Buangam (Day)", specialty: "力量与体能" },
      },
    },
    pricingSection: {
      title: "俱乐部价格表",
      subtitle: "选择适合您健身之旅的计划",
      getStarted: "立即开始",
      hour: "小时",
      categories: {
        pilates: {
          name: "普拉提器械课",
          plans: [
            { hours: "1", price: "18" },
            { hours: "10", price: "160" },
            { hours: "20", price: "300" },
            { hours: "30", price: "390" },
          ],
        },
        privateClass: {
          name: "私人课程（NERA老师）",
          plans: [
            { hours: "1", price: "45" },
            { hours: "10", price: "390" },
            { hours: "20", price: "760" },
            { hours: "30", price: "1080" },
          ],
        },
        muayThai: {
          name: "泰拳 & 团体课程",
          plans: [
            { hours: "1", price: "10" },
            { hours: "10", price: "90" },
            { hours: "20", price: "160" },
            { hours: "30", price: "210" },
            { hours: "50", price: "300" },
          ],
        },
      },
    },
    shopSection: {
      title: "商店",
      subtitle: "优质健身装备和补品",
      addToCart: "加入购物车",
      viewCart: "查看购物车",
      checkout: "结账",
      emptyCart: "您的购物车是空的",
      noProducts: "暂无商品",
    },
    contactSection: {
      title: "联系信息",
      phone: "电话",
      whatsapp: "WhatsApp",
      facebook: "Facebook",
      mainOffice: "总部",
    },
    footer: {
      description: "与最尊贵的健身社区一起改变您的身心。",
      quickLinks: "快速链接",
      schedule: "课程表",
      blog: "博客",
      hours: "营业时间",
      monSun: "周一 - 周日",
      contactTitle: "联系我们",
      copyright: "© 2026 VIP Fitness Club. 保留所有权利。",
      privacy: "隐私政策",
      terms: "服务条款",
    },
    chat: {
      title: "与我们聊天",
      subtitle: "我们通常在几分钟内回复",
      namePlaceholder: "您的姓名 *",
      emailPlaceholder: "邮箱",
      phonePlaceholder: "电话",
      messagePlaceholder: "我们能帮您什么? *",
      sendButton: "发送消息",
      requiredFields: "请填写必填项",
      messageSent: "消息发送成功!",
      messageError: "消息发送失败",
    },
    reels: {
      tagline: "最新动态",
      title: "健身视频",
    },
    crm: {
      sources: { manual: "手动添加", walk_in: "到店", tiktok: "TikTok", facebook: "Facebook", whatsapp: "WhatsApp", referral: "朋友推荐", advertisement: "广告", corporate: "企业客户", website: "网站", social: "社交媒体", other: "其他" },
      status: { new_lead: "新线索", contacted: "已联系", interested: "有兴趣", trial: "试用", follow_up: "跟进", negotiation: "谈判", won: "成交", lost: "流失" },
      report: {
        tab: "来源", title: "客户来源报告", monthly: "按月", yearly: "按年",
        source: "来源", leads: "新线索", trials: "试用人数", won: "成交", lost: "流失",
        revenue: "销售额", convRate: "成交率", total: "合计", noData: "此期间没有线索",
        topSource: "最佳来源", allSources: "所有来源", statusLabel: "销售状态",
        markWon: "标记成交", markLost: "标记流失", dealValue: "成交金额", wonValue: "成交金额",
        confirmWon: "确认此客户已成交？", lostReason: "原因（可选）",
        exportCsv: "导出 CSV", cancel: "取消", confirm: "确认", sourceDetail: "来源详情",
      },
      portal: { back: "返回管理", title: "CRM 门户" },
      header: { title: "CRM", subtitle: "联系人、销售管道、任务和活动审计跟踪" },
      tabs: { contacts: "联系人", pipeline: "管道", tasks: "任务", activity: "活动日志" },
      stats: { contacts: "联系人", openDeals: "进行中交易", pipelineValue: "管道价值", openTasks: "未完成任务", wonThisMonth: "本月赢得" },
      lifecycle: { lead: "线索", prospect: "潜在客户", customer: "客户", member: "会员", churned: "流失" },
      contacts: {
        title: "联系人", newContact: "新联系人",
        searchPlaceholder: "按姓名、邮箱、电话搜索…", allStages: "所有阶段",
        name: "姓名", contact: "联系方式", stage: "阶段", source: "来源", created: "创建时间",
        noContacts: "未找到联系人", showingFirst: "显示前 200 条结果 — 请细化搜索以缩小范围。",
        loadFailed: "加载联系人失败",
      },
      newContact: {
        title: "新联系人", fullName: "全名 *", email: "邮箱", phone: "电话", whatsapp: "WhatsApp",
        source: "来源", lifecycleStage: "生命周期阶段", notes: "备注",
        cancel: "取消", create: "创建联系人", saving: "保存中…",
        nameRequired: "姓名为必填项", created: "联系人已创建",
        sources: { manual: "手动", walk_in: "到店", website: "网站", referral: "推荐", social: "社交媒体" },
      },
      detail: {
        details: "详情", timeline: "时间线", tasks: "任务", deals: "交易",
        fullName: "全名", email: "邮箱", phone: "电话", whatsapp: "WhatsApp",
        source: "来源", lifecycleStage: "生命周期阶段", notes: "备注",
        save: "保存更改", saving: "保存中…", updated: "联系人已更新",
        addNotePlaceholder: "添加关于此联系人的备注…", log: "记录", noActivity: "暂无活动",
        taskTitle: "任务标题", low: "低", med: "中", high: "高",
        noTasks: "暂无任务", noDueDate: "无截止日期", taskAdded: "任务已添加",
        dealTitle: "交易标题（如：1年会员）", dealValue: "金额", stage: "阶段",
        noDeals: "暂无交易", titleStageRequired: "需要标题和阶段",
      },
      pipeline: {
        title: "销售管道", total: "总计", dropHere: "拖放交易到此",
        hint: "💡 在阶段间拖动交易以更新。从联系人详情页创建交易。",
        moveFailed: "移动交易失败",
      },
      tasks: {
        title: "任务和跟进",
        overdue: "逾期", today: "今天", upcoming: "即将", done: "已完成",
        noTasks: "暂无任务", noDueDate: "无截止日期",
      },
      activity: {
        searchPlaceholder: "搜索活动、联系人、操作者...",
        allActors: "所有操作者", system: "系统", allActivities: "所有活动", clear: "清除",
        showing: "显示", of: "共", activities: "活动",
        noMatch: "没有活动匹配当前筛选",
        types: {
          contact_created: "联系人创建", contact_updated: "联系人更新",
          deal_created: "交易创建", deal_stage_moved: "阶段移动", deal_updated: "交易更新",
          task_created: "任务创建", task_updated: "任务更新",
          task_completed: "任务完成", task_deleted: "任务删除",
        },
      },
    },
  },
  th: {
    nav: {
      classes: "คลาส",
      trainers: "เทรนเนอร์",
      pricing: "ราคา",
      shop: "ร้านค้า",
      contact: "ติดต่อ",
      feed: "ฟีด",
      joinNow: "สมัครเลย",
    },
    hero: {
      tagline: "เปลี่ยนแปลงร่างกายของคุณ",
      title1: "ก้าวข้าม",
      title2: "ขีดจำกัด",
      description: "เข้าร่วมชุมชนฟิตเนสสุดเอ็กซ์คลูซีฟ อุปกรณ์ทันสมัย เทรนเนอร์ระดับโลก และโปรแกรม VIP ที่ออกแบบมาเพื่อเปลี่ยนแปลงร่างกายของคุณ",
      startTrial: "เริ่มทดลองฟรี",
      watchVideo: "ดูวิดีโอ",
      members: "สมาชิก",
      classes: "คลาส",
      trainers: "เทรนเนอร์",
    },
    classesSection: {
      title: "คลาสแนะนำ",
      subtitle: "ค้นพบคลาสหลากหลายที่ออกแบบมาเพื่อท้าทายและเปลี่ยนแปลงคุณ",
      viewSchedule: "ดูตารางเรียน",
      bookNow: "จองเลย",
      classes: {
        pilates: { name: "พิลาทิส", description: "การออกกำลังกายเน้นแกนกลางลำตัวด้วยอุปกรณ์เฉพาะเพื่อสร้างความแข็งแรงและความยืดหยุ่น" },
        sprint: { name: "Sprint", description: "ปั่นจักรยานในร่มพลังสูง พร้อมแสงและเพลงที่เร้าใจ" },
        trx: { name: "TRX", description: "การฝึกแบบแขวนใช้น้ำหนักตัวเพื่อสร้างความแข็งแรงทั่วร่างกาย" },
        bodypump: { name: "Bodypump", description: "ออกกำลังกายทั้งตัวด้วยบาร์เบลล์ครอบคลุมกล้ามเนื้อหลัก" },
        combat: { name: "Combat", description: "คาร์ดิโอแนวศิลปะป้องกันตัวเพื่อความแข็งแรงและความอดทน" },
        zumba: { name: "Zumba", description: "ปาร์ตี้แดนซ์ฟิตเนสกับเพลงละตินและเพลงนานาชาติ" },
      },
    },
    trainersSection: {
      title: "เทรนเนอร์ระดับเอลีท",
      subtitle: "เรียนรู้จากผู้เชี่ยวชาญในวงการ",
      trainers: {
        nera: { name: "Neramit Sujarit (Nera)", specialty: "Group Exercise & MMA GX" },
        day: { name: "Lipatpong Buangam (Day)", specialty: "Strength & Conditioning" },
      },
    },
    pricingSection: {
      title: "รายการราคา",
      subtitle: "เลือกแพ็กเกจที่เหมาะกับเส้นทางฟิตเนสของคุณ",
      getStarted: "เริ่มต้น",
      hour: "ชั่วโมง",
      categories: {
        pilates: {
          name: "PILATES REFORMER",
          plans: [
            { hours: "1", price: "18" },
            { hours: "10", price: "160" },
            { hours: "20", price: "300" },
            { hours: "30", price: "390" },
          ],
        },
        privateClass: {
          name: "คลาสส่วนตัว (ครู NERA)",
          plans: [
            { hours: "1", price: "45" },
            { hours: "10", price: "390" },
            { hours: "20", price: "760" },
            { hours: "30", price: "1080" },
          ],
        },
        muayThai: {
          name: "มวยไทย & กลุ่มออกกำลังกาย",
          plans: [
            { hours: "1", price: "10" },
            { hours: "10", price: "90" },
            { hours: "20", price: "160" },
            { hours: "30", price: "210" },
            { hours: "50", price: "300" },
          ],
        },
      },
    },
    shopSection: {
      title: "ร้านค้า",
      subtitle: "อุปกรณ์ฟิตเนสและอาหารเสริมระดับพรีเมียม",
      addToCart: "เพิ่มลงตะกร้า",
      viewCart: "ดูตะกร้า",
      checkout: "ชำระเงิน",
      emptyCart: "ตะกร้าของคุณว่างเปล่า",
      noProducts: "ยังไม่มีสินค้า",
    },
    contactSection: {
      title: "ข้อมูลการติดต่อ",
      phone: "โทรศัพท์",
      whatsapp: "WhatsApp",
      facebook: "Facebook",
      mainOffice: "สำนักงานใหญ่",
    },
    footer: {
      description: "เปลี่ยนแปลงร่างกายและจิตใจของคุณกับชุมชนฟิตเนสสุดเอ็กซ์คลูซีฟ",
      quickLinks: "ลิงก์ด่วน",
      schedule: "ตารางเรียน",
      blog: "บล็อก",
      hours: "เวลาทำการ",
      monSun: "จันทร์ - อาทิตย์",
      contactTitle: "ติดต่อ",
      copyright: "© 2026 VIP Fitness Club. สงวนลิขสิทธิ์",
      privacy: "นโยบายความเป็นส่วนตัว",
      terms: "ข้อกำหนดการให้บริการ",
    },
    chat: {
      title: "แชทกับเรา",
      subtitle: "เรามักจะตอบกลับภายในไม่กี่นาที",
      namePlaceholder: "ชื่อของคุณ *",
      emailPlaceholder: "อีเมล",
      phonePlaceholder: "เบอร์โทร",
      messagePlaceholder: "เราช่วยอะไรคุณได้บ้าง? *",
      sendButton: "ส่งข้อความ",
      requiredFields: "กรุณากรอกข้อมูลที่จำเป็น",
      messageSent: "ส่งข้อความสำเร็จ!",
      messageError: "ส่งข้อความไม่สำเร็จ",
    },
    reels: {
      tagline: "อัปเดตล่าสุด",
      title: "วิดีโอฟิตเนส",
    },
    crm: {
      sources: { manual: "เพิ่มด้วยมือ", walk_in: "Walk-in", tiktok: "TikTok", facebook: "Facebook", whatsapp: "WhatsApp", referral: "เพื่อนแนะนำ", advertisement: "โฆษณา", corporate: "องค์กร", website: "เว็บไซต์", social: "โซเชียลมีเดีย", other: "อื่นๆ" },
      status: { new_lead: "ลูกค้าใหม่", contacted: "ติดต่อแล้ว", interested: "สนใจ", trial: "ทดลอง", follow_up: "ติดตาม", negotiation: "เจรจา", won: "ปิดการขาย", lost: "ไม่สำเร็จ" },
      report: {
        tab: "แหล่งที่มา", title: "รายงานแหล่งที่มาของลูกค้า", monthly: "รายเดือน", yearly: "รายปี",
        source: "แหล่งที่มา", leads: "ลูกค้าใหม่", trials: "มาทดลอง", won: "ปิดการขาย", lost: "ไม่สำเร็จ",
        revenue: "ยอดขาย", convRate: "อัตราปิดการขาย", total: "รวม", noData: "ไม่มีลูกค้าในช่วงนี้",
        topSource: "ช่องทางที่ดีที่สุด", allSources: "ทุกช่องทาง", statusLabel: "สถานะการขาย",
        markWon: "ปิดการขาย", markLost: "ไม่สำเร็จ", dealValue: "มูลค่าการขาย", wonValue: "มูลค่าการขาย",
        confirmWon: "ยืนยันปิดการขายลูกค้ารายนี้?", lostReason: "เหตุผล (ไม่บังคับ)",
        exportCsv: "ส่งออก CSV", cancel: "ยกเลิก", confirm: "ยืนยัน", sourceDetail: "รายละเอียดแหล่งที่มา",
      },
      portal: { back: "กลับไปแอดมิน", title: "พอร์ทัล CRM" },
      header: { title: "CRM", subtitle: "ผู้ติดต่อ ไปป์ไลน์การขาย งาน และบันทึกกิจกรรม" },
      tabs: { contacts: "ผู้ติดต่อ", pipeline: "ไปป์ไลน์", tasks: "งาน", activity: "บันทึกกิจกรรม" },
      stats: { contacts: "ผู้ติดต่อ", openDeals: "ดีลที่เปิด", pipelineValue: "มูลค่าไปป์ไลน์", openTasks: "งานที่เปิด", wonThisMonth: "ชนะเดือนนี้" },
      lifecycle: { lead: "ลีด", prospect: "ผู้สนใจ", customer: "ลูกค้า", member: "สมาชิก", churned: "ยกเลิก" },
      contacts: {
        title: "ผู้ติดต่อ", newContact: "เพิ่มผู้ติดต่อ",
        searchPlaceholder: "ค้นหาตามชื่อ อีเมล โทรศัพท์…", allStages: "ทุกขั้น",
        name: "ชื่อ", contact: "ติดต่อ", stage: "ขั้น", source: "ที่มา", created: "สร้างเมื่อ",
        noContacts: "ไม่พบผู้ติดต่อ", showingFirst: "แสดง 200 รายการแรก — โปรดปรับการค้นหาให้แคบลง",
        loadFailed: "โหลดผู้ติดต่อไม่สำเร็จ",
      },
      newContact: {
        title: "เพิ่มผู้ติดต่อ", fullName: "ชื่อเต็ม *", email: "อีเมล", phone: "โทรศัพท์", whatsapp: "WhatsApp",
        source: "ที่มา", lifecycleStage: "ขั้นวงจร", notes: "บันทึก",
        cancel: "ยกเลิก", create: "สร้างผู้ติดต่อ", saving: "กำลังบันทึก…",
        nameRequired: "กรุณาระบุชื่อ", created: "สร้างผู้ติดต่อสำเร็จ",
        sources: { manual: "ป้อนเอง", walk_in: "Walk-in", website: "เว็บไซต์", referral: "แนะนำ", social: "โซเชียลมีเดีย" },
      },
      detail: {
        details: "รายละเอียด", timeline: "ไทม์ไลน์", tasks: "งาน", deals: "ดีล",
        fullName: "ชื่อเต็ม", email: "อีเมล", phone: "โทรศัพท์", whatsapp: "WhatsApp",
        source: "ที่มา", lifecycleStage: "ขั้นวงจร", notes: "บันทึก",
        save: "บันทึกการเปลี่ยนแปลง", saving: "กำลังบันทึก…", updated: "อัปเดตผู้ติดต่อสำเร็จ",
        addNotePlaceholder: "เพิ่มบันทึกเกี่ยวกับผู้ติดต่อนี้…", log: "บันทึก", noActivity: "ยังไม่มีกิจกรรม",
        taskTitle: "ชื่องาน", low: "ต่ำ", med: "กลาง", high: "สูง",
        noTasks: "ไม่มีงาน", noDueDate: "ไม่มีกำหนด", taskAdded: "เพิ่มงานสำเร็จ",
        dealTitle: "ชื่อดีล (เช่น สมาชิก 1 ปี)", dealValue: "มูลค่า", stage: "ขั้น",
        noDeals: "ไม่มีดีล", titleStageRequired: "ต้องระบุชื่อและขั้น",
      },
      pipeline: {
        title: "ไปป์ไลน์การขาย", total: "รวม", dropHere: "วางดีลที่นี่",
        hint: "💡 ลากดีลระหว่างขั้นเพื่ออัปเดต สร้างดีลจากหน้ารายละเอียดผู้ติดต่อ",
        moveFailed: "ย้ายดีลไม่สำเร็จ",
      },
      tasks: {
        title: "งานและการติดตาม",
        overdue: "เกินกำหนด", today: "วันนี้", upcoming: "กำลังจะถึง", done: "เสร็จแล้ว",
        noTasks: "ไม่มีงาน", noDueDate: "ไม่มีกำหนด",
      },
      activity: {
        searchPlaceholder: "ค้นหากิจกรรม ผู้ติดต่อ ผู้ดำเนินการ...",
        allActors: "ผู้ดำเนินการทั้งหมด", system: "ระบบ", allActivities: "กิจกรรมทั้งหมด", clear: "ล้าง",
        showing: "แสดง", of: "จาก", activities: "กิจกรรม",
        noMatch: "ไม่มีกิจกรรมที่ตรงกับตัวกรอง",
        types: {
          contact_created: "สร้างผู้ติดต่อ", contact_updated: "อัปเดตผู้ติดต่อ",
          deal_created: "สร้างดีล", deal_stage_moved: "ย้ายขั้น", deal_updated: "อัปเดตดีล",
          task_created: "สร้างงาน", task_updated: "อัปเดตงาน",
          task_completed: "งานเสร็จ", task_deleted: "ลบงาน",
        },
      },
    },
  },
};

export const languageNames: Record<Language, string> = {
  en: "English",
  lo: "ລາວ",
  zh: "中文",
  th: "ไทย",
};
